import api from "./api";
import { push } from "react-router-redux";

export const LOGIN_REQUEST = 'user/LOGIN/REQUEST';
export const LOGIN_SUCCESS = 'user/LOGIN/SUCCESS';
export const LOGIN_FAILURE = 'user/LOGIN/FAILURE';
export const REFRESH_TOKEN_REQUEST = 'user/REFRESH_TOKEN/REQUEST';
export const REFRESH_TOKEN_SUCCESS = 'user/REFRESH_TOKEN/SUCCESS';
export const REFRESH_TOKEN_FAILURE = 'user/REFRESH_TOKEN/FAILURE';
export const USER_UPDATE_REQUEST = 'user/UPDATE/REQUEST';
export const USER_UPDATE_SUCCESS = 'user/UPDATE/SUCCESS';
export const USER_UPDATE_FAILURE = 'user/UPDATE/FAILURE';
export const LOGOUT = 'user/LOGOUT';
export const USER_RELOAD_REQUEST = 'user/RELOAD/REQUEST';
export const USER_RELOAD_SUCCESS = 'user/RELOAD/SUCCESS';
export const USER_RELOAD_FAILURE = 'user/RELOAD/FAILURE';

export function login(username, password) {

    return dispatch => {
        dispatch(request({username}));

        api.login(username, password)
            .then(
                user => {
                    dispatch(success(user));
                    dispatch(push('/'));
                },
                error => {
                    handleErrorCode(error,dispatch);
                    dispatch(failure(error));
                }
            );
    };

    function request(user) {
        return {type: LOGIN_REQUEST, user}
    }

    function success(user) {
        return {type: LOGIN_SUCCESS, user}
    }

    function failure(error) {
        return {type: LOGIN_FAILURE, error}
    }
}

export function refreshToken(username, password) {

    return dispatch => {
        dispatch(request({username}));

        api.refreshToken()
            .then(
                user => {
                    dispatch(success(user));
                    dispatch(push('/'));
                },
                error => {
                    handleErrorCode(error,dispatch);
                    dispatch(failure(error));
                }
            );
    };

    function request(user) {
        return {type: REFRESH_TOKEN_REQUEST, user}
    }

    function success(user) {
        return {type: REFRESH_TOKEN_SUCCESS, user}
    }

    function failure(error) {
        return {type: REFRESH_TOKEN_FAILURE, error}
    }
}

export function logout() {
    api.logout();
    return {type: LOGOUT};
}

export function updateUser(user) {
    return dispatch => {
        dispatch(request({user}));

        api.update(user)
            .then(
                user => {
                    dispatch(success(user));
                },
                error => {
                    handleErrorCode(error,dispatch);
                    dispatch(failure(error));
                }
            );
    };

    function request(user) {
        return {type: USER_UPDATE_REQUEST, user}
    }

    function success(user) {
        return {type: USER_UPDATE_SUCCESS, user}
    }

    function failure(error) {
        return {type: USER_UPDATE_FAILURE, error}
    }
}

export function reloadUser() {
    return dispatch => {
        dispatch(request());

        api.reload()
            .then(
                user => {
                    dispatch(success(user));
                },
                error => {
                    handleErrorCode(error,dispatch);
                    dispatch(failure(error));
                }
            );
    };

    function request(user) {
        return {type: USER_RELOAD_REQUEST, user}
    }

    function success(user) {
        return {type: USER_RELOAD_SUCCESS, user}
    }

    function failure(error) {
        return {type: USER_RELOAD_FAILURE, error}
    }
}

function handleErrorCode(error, dispatch) {
    if(error === 401){
        dispatch(logout());
    }
}



// WEBPACK FOOTER //
// ./src/data/user/actions.js